export enum LOGIN_ROUTES {
	EMAIL = '/login/email',
	CHECK_INBOX = '/login/email/inbox',
	LOGIN_CONFIRM = '/login/email/confirm',
	EMAIL_HELP = '/login/email/help',
	PASSWORD = '/login/password',
	ERROR = '/login/error',
	COMPLETE = '/login/complete',
}
